const DEFAULT_BOOKING_HOST = 'booking.dev.zocks.io'

export const normalizeBookingHost = (value: string | undefined): string => (value || DEFAULT_BOOKING_HOST).replace(/^https?:\/\//, '').replace(/\/+$/, '')

export const BOOKING_BASE_URL = normalizeBookingHost(import.meta.env.REACT_APP_BOOKING_BASE_URL)
